<template>
   <div>
      <el-upload
         v-loading="loading.file"
         :model="file"
         class="uploader-pedale"
         action=""
         :before-remove="beforeRemove"
         :on-change="setFile"
         :multiple="false"
         :limit="3"
         :on-exceed="handleExceed"
         :file-list="fileList"
         :auto-upload="false"
      >
         <el-button
            class="w-100 font-strong"
            size="mini"
            type="blue"
            plain>
            {{textButton}}
         </el-button>
      </el-upload>
   </div>
</template>

<script>
import header from "@/services/header"
import imageCompression from "browser-image-compression";
import UserService from '@/services/user.service';
export default {
   name: 'Uploader',
   props: {
      userId: String,
      nameSpace: String,
      textButton: {
         type: String,
         default: 'Selecionar Arquivo'
      }
   },
   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         file: null,
         loading: {
            saveFile: false,
            file: false
         },
         fileList: [],
      }
   },
   methods: {

      setFile(file) {

         this.loading.file = true
         this.fileUri = ''

         setTimeout(() => {
            if (this.photoIsOK(file)) {

               let fileRaw = file.raw;

               let options = {
                  maxSizeMB: 0.5,
                  useWebWorker: true,
                  maxIteration: 50,
                  onProgress: () => false
               };

               if (fileRaw.type === "image/pdf" || fileRaw.type === "application/pdf") {
                  this.file = fileRaw;
                  this.postImage()
                  this.loading.file = false
               } else {
                  imageCompression(fileRaw, options)
                     .then((compressedFile) => {
                        this.fileUri = URL.createObjectURL(compressedFile);
                        this.file = compressedFile;
                        this.postImage()
                        this.loading.file = false
                     })
                     .catch(function (error) {
                        this.$message.error(`Ops, algo deu errado. Erro: ${error}`);
                     })
                     .finally(() => {
                        this.loading.file = false
                     })
               }
            }

         }, 100)

      },

      postImage() {
         let formData = new FormData();
         formData.append('file', this.file);
         formData.append('nameSpace', this.nameSpace);

         const fileUrl = `${this.baseUrl + this.apiV1}/site/upload`;

         this.loading.file = true
         this.axios.post(fileUrl, formData, header)
            .then(async (response) => {
               this.$emit('file', response.data.doc)
               this.$message({
                  message: response.data.message,
                  type: 'success'
               });
               await this.getUser()
               this.loading.file = false
            })
            .catch((e => {
               this.$message.error(e.response.data.message);
               this.loading.file = false
            }));
      },

      removeFile() {
         const fileUri = `${this.baseUrl + this.apiV1}/site/upload`;
         this.$confirm('Você tem certeza que quer deletar o arquivo?', 'Deletar arquivo', {
            confirmButtonText: 'Sim, quero deletar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
         }).then(() => {
            this.axios.delete(fileUri, header)
               .then(async (response) => {
                  this.$message({
                     message: response.data.message,
                     type: 'success'
                  });
                  this.user.avatar.filename = ''
                  await this.getUser();

               })
               .catch((e => {
                  this.$message.error(e.response.data.message);
               }));
         })
      },

      photoIsOK(file) {

         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/pdf', 'application/pdf'];

         if (!allowedTypes.includes(file.raw.type)) {
            this.$message.error('ATENÇÃO: Somente imagens no formato JPEG, JPG, PNG e PDF');
            this.loading.file = false;
            return false;
         }

         const maxSize = file.raw.size > 10000000;

         if (maxSize) {
            this.$message.error('O arquivo não deve ser maior que 10mb.');
            this.loading.file = false;
            return false
         }

         return true;
      },

      handleExceed(files, fileList) {
         this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      },

      beforeRemove(file) {
         return this.$confirm(`Cancel the transfert of ${ file.name } ?`);
      },
      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },
   },
   computed: {
      userData() {
         return this.$store.state.user
      }
   },
}
</script>

<style lang="scss">
.uploader-pedale {
   position: relative;

   .el-loading-mask {
      background-color: rgba(255, 255, 255, 0.5);

      .el-loading-spinner {
         margin-top: -13px;
         .circular {
            height: 22px;
            width: 22px;
         }
      }
   }

   .el-upload-list {
      position: absolute;
      top: 1px;
      background: #e3f1fe;
      left: 1px;
      width: calc(100% - 2px);
      padding-right: 7px;
      border-radius: 2px;

      .el-upload-list__item {
         margin: 4px;
      }
   }
}
</style>
